<template>
  <div>
    <b-card no-body class="overflow-hidden m-auto" style="max-height: 200px">
      <b-row no-gutters>
        <b-col md="6">
          <b-card-img
            src="https://picsum.photos/400/400/?image=20"
            alt="Image"
            class="rounded-0"
          ></b-card-img>
        </b-col>
        <b-col md="6">
          <b-card-body title="Horizontal Card">
            <b-card-text>
              This is a wider card with supporting text as a natural lead-in to
              additional content. This content is a little bit longer.
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  created() {
    //
  },
  props: {
    name: {
      type: String,
      required: false,
    },
    linkURL: {
      type: String,
      required: false,
    },
    imageURL: {
      type: String,
      required: false,
    },
  },
};
</script>
